import { useUserStore } from '#stores/user.store';
import type { NavigationGuard } from 'vue-router';
import { routes } from '../routes';

export const onboardingGuard: NavigationGuard = (to) => {
  const userStore = useUserStore();

  if (userStore.isUserOnboarding && !to.meta.isOnboarding) {
    return { name: routes.onboarding.name };
  }
};
